import styles from './DateSeparator.module.css';

interface DateSeparatorProps {
  date: string; // ISO 8601
}

function formatDateLabel(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diff = today.getTime() - target.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
}

export function DateSeparator({ date }: DateSeparatorProps) {
  return (
    <div class={styles.separator}>
      <hr class={styles.rule} />
      <span class={styles.label}>{formatDateLabel(date)}</span>
      <hr class={styles.rule} />
    </div>
  );
}
